/* This file is autogenerated, see readme.md for instructions */
import CloudCheckSvgIcon from '@bloomreach/banana-theme/icons/cloud-check.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const CloudCheckIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <CloudCheckSvgIcon />
    </Icon>
  );
});

CloudCheckIcon.displayName = 'CloudCheckIcon';

export default CloudCheckIcon;
